import request from "./account.js";

export const unreadCount = () =>
    request({
        method: 'get',
        url: '/messenger/unreadCount',
        stopLoading: true
    });